



















































import Vue from 'vue'
import Component from 'vue-class-component'
import Table from '@/components/tables/Table.vue'
import TableSubRow from '@/components/tables/TableSubRow.vue'
import Icon from '@/components/Icon.vue'
import { ITableConfig } from '@/interfaces'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import moment from 'moment'
import { IEligibilityTask, IPatientLiability } from '@zunta/configurations'
import { EligibilityTaskModule } from '@/store/modules/eligibilityTask.module'
import { getModule } from 'vuex-module-decorators'
import Checkbox from '@/components/inputsV2/Checkbox.vue'

@Component({
  props: {
    task: {
      type: Object as () => IEligibilityTask,
      required: true
    }
  },
  components: {
    Checkbox,
    InputV2,
    Icon,
    TableSubRow,
    Table
  }
})
export default class EligibilityTaskSubrow extends Vue {
  eligibilityTaskModuleInstance: EligibilityTaskModule = getModule(EligibilityTaskModule, this.$store)
  patientLiability: IPatientLiability[] = [{
    liabilityRow: '',
    amount: '',
    dateFrom: '',
    dateTo: ''
  }]
  noPatientLiabilityData: boolean = false
  config: ITableConfig = {
    columns: [
      {
        minWidth: '130px',
        width: 20,
        key: 'inputRow'
      },
      {
        minWidth: '100px',
        width: 20,
        key: 'amount',
        label: 'Patient Liability'
      },
      {
        minWidth: '100px',
        width: 20,
        key: 'dateFrom',
        label: 'Date From'
      },
      {
        minWidth: '100px',
        width: 20,
        key: 'dateTo',
        label: 'Date To'
      },
      {
        minWidth: '130px',
        width: 20,
        key: 'actions'
      }
    ]
  }

  mounted () {
    if (this.$props.task.outgoingData && this.$props.task.outgoingData.length) {
      this.patientLiability = this.$props.task.outgoingData
    }
    this.noPatientLiabilityData = this.$props.task.noPatientLiabilityData
  }

  updatePatientLiabilityItemFields (item: IPatientLiability) {
    // Unambiguous date formats, including non-zero-padded versions
    const dateFormats = [
      // Year-first formats
      'YYYY-MM-DD', // ISO standard
      'YYYY/MM/DD',
      'YYYY.MM.DD',
      'YYYY-M-D', // Non-zero-padded dashes
      'YYYY/M/D', // Non-zero-padded slashes
      'YYYY.M.D', // Non-zero-padded dots

      // Day-month-year formats
      'DD.MM.YYYY',
      'DD-MM-YYYY',
      'D.M.YYYY', // Non-zero-padded dots
      'D-M-YYYY', // Non-zero-padded dashes

      // Month-day-year formats
      'MM/DD/YYYY',
      'M/D/YYYY', // Non-zero-padded slashes
      'MM.DD.YYYY',
      'M.D.YYYY' // Non-zero-padded dots
    ]

    // Split input by any whitespace and filter out empty entries
    const parts = item.liabilityRow.split(/\s+/).filter(Boolean)

    item.amount = parts[0].replace(/[^0-9.]/g, '') || ''

    item.dateFrom = parts[1]
      ? moment(parts[1], dateFormats, true).isValid()
        ? moment(parts[1], dateFormats).format('MM/DD/YYYY')
        : 'Invalid Date'
      : ''

    item.dateTo = parts[2]
      ? moment(parts[2], dateFormats, true).isValid()
        ? moment(parts[2], dateFormats).format('MM/DD/YYYY')
        : 'Invalid Date'
      : ''

    const isValid = this.patientLiability.every(item => {
      return item.amount && item.dateFrom && item.dateTo && item.dateFrom !== 'Invalid Date' && item.dateTo !== 'Invalid Date'
    })

    if (isValid) {
      // Add the new item
      this.patientLiability.push({
        liabilityRow: '',
        amount: '',
        dateFrom: '',
        dateTo: ''
      })
    }
  }

  deletePatientLiabilityItem (item: IPatientLiability) {
    if (this.patientLiability.length === 1) {
      this.patientLiability = [{
        liabilityRow: '',
        amount: '',
        dateFrom: '',
        dateTo: ''
      }]
      return
    }
    const index = this.patientLiability.indexOf(item)
    if (index !== -1) {
      this.patientLiability.splice(index, 1)
    }
  }

  async submitPatientLiability () {
    const validLiability = this.patientLiability.filter(item => {
      return item.amount && item.dateFrom && item.dateTo && item.dateFrom !== 'Invalid Date' && item.dateTo !== 'Invalid Date'
    })
    if (!validLiability.length && !this.noPatientLiabilityData) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Error',
        message: 'No valid patient liabilities',
        icon: 'warning'
      })
      return
    }
    const result = await this.eligibilityTaskModuleInstance.submitPatientLiability({ taskId: this.$props.task.id, data: validLiability, noPatientLiabilityData: this.noPatientLiabilityData })
    if (result.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Error',
        message: result.message,
        icon: 'warning'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        header: 'Success',
        message: this.noPatientLiabilityData ? 'Submitted with no liability data' : 'Patient liabilities submitted',
        icon: 'check'
      })
      this.$eventBus.$emit('getEligibilityTasks')
    }
  }
}
